

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const retryWithDelay = async (asyncFn, maxRetries = 3, delayMs = 2000, shouldRetry = () => true) => {
  let lastResult;
  let lastError;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const result = await asyncFn();
      lastResult = result;

      if (!shouldRetry(result)) {
        return result; // Success or non-retryable condition met
      }

      if (attempt < maxRetries) {
        // eslint-disable-next-line no-await-in-loop
        await delay(delayMs);
      }
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries) {
        // eslint-disable-next-line no-await-in-loop
        await delay(delayMs);
      }
    }
  }

  // Return last result even if retryable (exhausted retries)
  // This allows the caller to handle the final response
  if (lastError && !lastResult) {
    throw lastError;
  }
  return lastResult;
};
